import { useTheme } from '@mui/material/styles';

export function useIsSmallSizeThemeVariant() {
  const theme = useTheme();
  return theme.components?.MuiOutlinedInput?.defaultProps?.size === 'small';
}
